import React from 'react';
import { motion } from 'framer-motion';

// Assets
import logo from '../assets/logo1.png'; 
import locationIcon from '../assets/address-icon.png'; 
import callIcon from '../assets/phone-icon.png'; 
import mailIcon from '../assets/email-icon.png'; 
import eduBg from '../assets/edu-bg.jpg'; 
import fbIcon from '../assets/fb.png';
import waIcon from '../assets/whatsapp.png';
import ytIcon from '../assets/youtube.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer 
      className="bg-[#020617] text-white pt-16 md:pt-24 pb-12 font-sans border-t border-white/[0.03] relative overflow-hidden text-center md:text-left bg-cover bg-center" 
      style={{ backgroundImage: `url(${eduBg})` }}
    >
      
      {/* --- GRADIENT OVERLAY --- */}
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-t from-[#020617] via-[#020617]/95 to-[#020617]/90 z-0"></div>
      
      {/* --- WATERMARK - Mobile එකේදී ටිකක් කුඩා කළා --- */}
      <div className="absolute -bottom-10 -right-10 md:-bottom-20 md:-right-20 opacity-[0.03] md:opacity-[0.05] pointer-events-none select-none z-0">
        <img src={logo} alt="" className="w-[300px] md:w-[500px] h-auto grayscale" />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 mb-16 md:mb-20">
          
          {/* LOGO & ABOUT */}
          <div className="lg:col-span-5 space-y-8 md:space-y-10">
            <div className="space-y-6 flex flex-col items-center md:items-start">
              <img 
                src={logo} 
                alt="Vidulaka Logo" 
                className="w-40 md:w-48 h-auto object-contain transition-all duration-700 grayscale hover:grayscale-0 opacity-90 hover:opacity-100" 
              />
              <p className="text-slate-400 text-sm md:text-[15px] leading-relaxed font-light max-w-sm tracking-wide">
                Dedicated to academic excellence and character building, Vidulaka Institute stands as Matale's premier destination for holistic education.
              </p>
            </div>
            
            {/* SOCIAL ICONS */}
            <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-6">
               <span className="text-[10px] md:text-[11px] font-black uppercase tracking-[0.3em] text-slate-500">Connect</span>
               <div className="flex space-x-4">
                  {[
                    { src: fbIcon, alt: 'FB' },
                    { src: waIcon, alt: 'WA' },
                    { src: ytIcon, alt: 'YT' }
                  ].map((social, index) => (
                    <a 
                      key={index} 
                      href="#" 
                      className="w-11 h-11 rounded-xl bg-white/[0.03] border border-white/5 flex items-center justify-center hover:bg-white/[0.1] transition-all duration-300 group shadow-lg"
                    >
                      <img 
                        src={social.src} 
                        alt={social.alt} 
                        className="w-6 h-6 object-contain opacity-90 group-hover:opacity-100 transition-all duration-300" 
                      />
                    </a>
                  ))}
               </div>
            </div>
          </div>

          {/* NAVIGATION LINKS - Mobile එකේදී grid 2ක් කළා */}
          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-10 md:gap-12 text-left">
            <div className="space-y-6 md:space-y-8">
              <h4 className="text-[11px] md:text-[13px] font-black uppercase tracking-[0.2em] md:tracking-[0.3em] text-white/90">The Institute</h4>
              <ul className="space-y-4 md:space-y-5 text-sm md:text-[15px] text-slate-400 font-medium">
                {['Our Story', 'Faculty Profiles', 'Admissions'].map(item => (
                  <li key={item}><a href="#" className="hover:text-white transition-all duration-300 flex items-center group">
                    <span className="w-0 group-hover:w-3 h-[1.5px] bg-red-600 mr-0 group-hover:mr-2 transition-all"></span>
                    {item}
                  </a></li>
                ))}
              </ul>
            </div>

            <div className="space-y-6 md:space-y-8">
              <h4 className="text-[11px] md:text-[13px] font-black uppercase tracking-[0.2em] md:tracking-[0.3em] text-white/90">Academics</h4>
              <ul className="space-y-4 md:space-y-5 text-sm md:text-[15px] text-slate-400 font-medium">
                {['Programmes', 'Exam Schedules', 'LMS Portal'].map(item => (
                  <li key={item}><a href="#" className="hover:text-white transition-all duration-300 flex items-center group">
                    <span className="w-0 group-hover:w-3 h-[1.5px] bg-red-600 mr-0 group-hover:mr-2 transition-all"></span>
                    {item}
                  </a></li>
                ))}
              </ul>
            </div>

            <div className="space-y-6 md:space-y-8 hidden md:block">
              <h4 className="text-[11px] md:text-[13px] font-black uppercase tracking-[0.3em] text-white/90">Resources</h4>
              <ul className="space-y-5 text-[15px] text-slate-400 font-medium">
                <li><a href="#" className="hover:text-white transition-colors">Study Material</a></li>
                <li><a href="#" className="hover:text-white transition-colors">News Updates</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Support Desk</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* CONTACT BAR - Mobile එකේදී එක යට එක වැටෙනවා */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 py-10 md:py-12 border border-white/5 mb-12 bg-white/[0.02] backdrop-blur-md px-6 md:px-8 rounded-[2rem] relative z-10 shadow-2xl">
           
           {/* Location */}
           <div className="flex flex-col md:flex-row items-center md:items-start md:space-x-6 group text-center md:text-left">
              <div className="w-14 h-14 rounded-2xl bg-white/[0.03] border border-white/5 flex items-center justify-center group-hover:bg-red-600/10 transition-all duration-500 shadow-lg mb-4 md:mb-0">
                <img src={locationIcon} alt="" className="w-6 h-6 md:w-7 md:h-7 opacity-70 group-hover:opacity-100 transition-all" />
              </div>
              <div>
                <p className="text-[10px] md:text-[11px] text-red-500 uppercase font-black tracking-widest mb-1.5">Visit Campus</p>
                <p className="text-white text-sm md:text-[16px] font-semibold tracking-wide">No 12, Main Street, Matale</p>
              </div>
           </div>

           {/* Call */}
           <div className="flex flex-col md:flex-row items-center md:items-start md:space-x-6 group text-center md:text-left border-y md:border-y-0 md:border-x border-white/5 py-8 md:py-0 md:px-10">
              <div className="w-14 h-14 rounded-2xl bg-white/[0.03] border border-white/5 flex items-center justify-center group-hover:bg-red-600/10 transition-all duration-500 mb-4 md:mb-0">
                <img src={callIcon} alt="" className="w-6 h-6 md:w-7 md:h-7 opacity-70 group-hover:opacity-100" />
              </div>
              <div>
                <p className="text-[10px] md:text-[11px] text-red-500 uppercase font-black tracking-widest mb-1.5">Direct Line</p>
                <p className="text-white text-sm md:text-[16px] font-semibold tracking-wide">+94 66 222 3344</p>
              </div>
           </div>

           {/* Mail */}
           <div className="flex flex-col md:flex-row items-center md:items-start md:space-x-6 group text-center md:text-left">
              <div className="w-14 h-14 rounded-2xl bg-white/[0.03] border border-white/5 flex items-center justify-center group-hover:bg-red-600/10 transition-all duration-500 mb-4 md:mb-0">
                <img src={mailIcon} alt="" className="w-6 h-6 md:w-7 md:h-7 opacity-70 group-hover:opacity-100" />
              </div>
              <div>
                <p className="text-[10px] md:text-[11px] text-red-500 uppercase font-black tracking-widest mb-1.5">Enquiries</p>
                <p className="text-white text-sm md:text-[16px] font-semibold tracking-wide">info@vidulaka.lk</p>
              </div>
           </div>

        </div>

        {/* BOTTOM SECTION */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 md:gap-8 pt-4 text-[9px] md:text-[11px] font-bold tracking-widest uppercase text-slate-600">
          <div className="flex items-center space-x-3 order-2 md:order-1">
             <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse shadow-[0_0_8px_rgba(34,197,94,0.4)]"></div>
             <p className="text-slate-500">All Systems Operational</p>
          </div>
          <p className="order-1 md:order-2">© {currentYear} Vidulaka Matale. <span className="text-slate-700 ml-1 md:ml-2">Smart Class Systems</span></p>
          <div className="flex space-x-6 md:space-x-8 order-3">
            <a href="#" className="hover:text-white transition-colors">Privacy</a>
            <a href="#" className="hover:text-white transition-colors">Terms</a>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;